// extracted by mini-css-extract-plugin
module.exports = {"optionstitle":"index-styles_optionstitle__10bmk","optionsconteiner":"index-styles_optionsconteiner__1GS8C","optionsbutton":"index-styles_optionsbutton__1US3m"};